import React, {ReactElement} from 'react';
import './index.scss';

const NotFound: React.FC = (): ReactElement => {
  return (
    <article className="sb-ErrorPage-404">
      <div className="sb-Wrapper">
        <div className="sb-ErrorPage-404-content">
          <h2 className="sb-ErrorPage-header">Ah, tentacles</h2>
          <p className="sb-ErrorPage-info">
            This isn&apos;t the page you were looking for. Please double check
            your link.
          </p>
        </div>
      </div>
    </article>
  );
};

export default NotFound;
